<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row class="details">
                <b-col lg="12" sm="12">
                    <b-row>
                        <b-col xs="12" sm="12" md="8" class="text-left mb-2">
                            <h5>{{ (currentLocale === 'en') ? profile.name + "'s" : profile.name_bn + ' এর ' }} {{ $t('rehabilitation_management.rehabilitation_information') + ' ' + $t('globalTrans.details') }}</h5>
                        </b-col>
                        <b-col xs="12" sm="12" md="4" class="text-right mb-2">
                            <b-button-group>
                                <b-button @click="pdfExport()" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="12" sm="12">
                            <b-row>
                                <b-col md=12>
                                    <b-table-simple striped bordered small hover>
                                        <tbody>
                                            <b-tr>
                                                <b-td>{{ $t('globalTrans.organization') }}</b-td>
                                                <b-td>{{ getOrgName(profile.org_id) }}</b-td>
                                                <b-td>{{ $t('child_configuration.institute_type') }}</b-td>
                                                <b-td>{{ getInstituteType(profile.office_type_id) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('child_configuration.institute_name') }}</b-td>
                                                <b-td>{{ (currentLocale === 'en') ? profile.institute_name : profile.institute_name_bn }}</b-td>
                                                <b-td>{{ $t('globalTrans.date') }}</b-td>
                                                <b-td>{{ profile.date | dateFormat }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('rehabilitation_management.applicant_name') }}</b-td>
                                                <b-td>{{ (currentLocale === 'en') ? profile.name : profile.name_bn }}</b-td>
                                                <b-td>{{ $t('rehabilitation_management.registration_id') }}</b-td>
                                                <b-td>{{ profile.registration_id }}</b-td>
                                            </b-tr>
                                             <b-tr>
                                                <b-td>{{ $t('child_configuration.rehabilitation_type') }}</b-td>
                                                <b-td>
                                                    <span v-if="profile.rehabilitation_type_id === 4">{{ getRehabilitationTypeList(profile.rehabilitation_type_id) }} {{ '(' }}{{ (currentLocale === 'en') ? profile.rehabilitation_to : profile.rehabilitation_to_bn }}{{ ')' }}</span>
                                                    <span v-else>{{ getRehabilitationTypeList(profile.rehabilitation_type_id) }}</span>
                                                </b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('rehabilitation_management.contact_no') }}</b-td>
                                                <b-td>{{ profile.contact_no }}</b-td>
                                                <b-td>{{ $t('rehabilitation_management.rehabilitation_to') }}</b-td>
                                                <b-td>{{ (currentLocale === 'en') ? profile.rehabilitation_to : profile.rehabilitation_to_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('org_pro.area_type') }}</b-td>
                                                <b-td>{{ getAreaType(profile.area_type_id) }}</b-td>
                                                <b-td>{{ $t('org_pro_division.division') }}</b-td>
                                                <b-td>{{ getDivisionName(profile.division_id) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('org_pro_district.district') }}</b-td>
                                                <b-td>{{ getDistrictName(profile.district_id) }}</b-td>
                                                <b-td>{{ $t('org_pro_upazilla.upazilla') }}</b-td>
                                                <b-td>{{ profile.upazila_id ? getUpazilaName(profile.upazila_id) : 'N/A' }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('org_pro_union.union') }}</b-td>
                                                <b-td>{{ profile.union_id ? getUnionName(profile.union_id) : 'N/A' }}</b-td>
                                                <b-td>{{ $t('org_pro.city_corporation') }}</b-td>
                                                <b-td>{{ profile.city_corporation_id ? getCityCorpName(profile.city_corporation_id) : 'N/A' }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('educational_management.pourosoba') }}</b-td>
                                                <b-td>{{ profile.paurasabha_id ? getPourosobaName(profile.paurasabha_id) : 'N/A' }}</b-td>
                                                <b-td>{{ $t('org_pro.ward') }}</b-td>
                                                <b-td>{{ profile.ward_id ? getWardName(profile.ward_id) : 'N/A' }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('child_admission_management.address') }}</b-td>
                                                <b-td>{{ (currentLocale === 'en') ? profile.address : profile.address_bn }}</b-td>
                                                <b-td>{{ $t('legal_institute_management.remarks') }}</b-td>
                                                <b-td>{{ (currentLocale === 'en') ? profile.remarks : profile.remarks_bn }}</b-td>
                                            </b-tr>
                                        </tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import Custom from '../../../../../store/custom'
import ExportPdf from './export-pdf'
import { childServiceBaseUrl } from '@/config/api_config'

export default {
  props: ['id'],
  components: {
  },
  data () {
    return {
      profile: {
      }
    }
  },
  created () {
    if (this.id) {
        const tmp = this.getRehabInformation()
        this.profile = tmp
    }
  },
  mounted () {
    core.index()
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
  },
  methods: {
    getWardName (Id) {
        const tmpData = this.$store.state.commonObj.wardList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getUnionName (Id) {
        const tmpData = this.$store.state.commonObj.unionList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getUpazilaName (Id) {
        const tmpData = this.$store.state.commonObj.upazilaList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getDivisionName (Id) {
        const tmpData = this.$store.state.commonObj.divisionList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
     getRehabilitationTypeList (typeId) {
        const Type = this.$store.state.ChildService.commonObj.rehabilitationTypeList.find(type => type.value === typeId)
        if (this.$i18n.locale === 'bn') {
            return Type.text_bn
        } else {
            return Type.text_en
        }
    },
    getPourosobaName (Id) {
        const tmpData = this.$store.state.commonObj.pauroshobaList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getCityCorpName (Id) {
        const tmpData = this.$store.state.commonObj.cityCorporationList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getDistrictName (Id) {
        const tmpData = this.$store.state.commonObj.districtList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getAreaType (Id) {
        const tmpData = Custom.wardTypeList.find(item => item.id === Id)
        if (this.$i18n.locale === 'bn') {
            return tmpData.name_bn
        } else {
            return tmpData.name
        }
    },
    getOrgName (orgId) {
        const tmpData = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getInstituteType (Id) {
        const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getRehabInformation () {
        const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
        return JSON.parse(JSON.stringify(tmpData))
    },
    pdfExport () {
        const reportTitle = this.$t('rehabilitation_management.rehabilitation_information') + ' ' + this.$t('globalTrans.details')
        ExportPdf.exportPdfDetails(childServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, this.profile, this)
    }
  }
}
</script>
<style lang="scss">
    .details {
    h5 {
      color: green !important;
      font-size: 20px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
  }
  .hidden_header {
    display: none
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .mytd{
        padding: 0.45rem 0.75rem 0.45rem 0.75rem !important;
    }
</style>
